import { FeatureConfiguration } from "features";
import { reducer } from "./reducers";

export default function (config: FeatureConfiguration) {
    config.reducers.roles = reducer;
}
